// eslint-disable-next-line no-restricted-imports
import { OperationListItemFragment } from 'api/generated/graphql';
import { OperationListItemData } from 'api/types/data/operation';
import { OperationStatusType, OperationType } from 'api/types/entity/operation';
import { OrderOperationType } from 'api/types/entity/order';
import { OrderExecutionTermsOrderType } from 'api/types/entity/order/orderExecutionTermsEntity';
import { OrderStatusType } from 'api/types/entity/order/orderStatusType';

import { parseExecutionPlaceEntity } from '../parseExecutionPlaceEntity';
import { parseManagerData } from '../parseManagerData';

export const parseOperationListItemData = (
  operation: OperationListItemFragment
): OperationListItemData => ({
  id: operation.id,
  status: OperationStatusType[operation.status],
  trader: operation.trader ? parseManagerData(operation.trader) : undefined,
  settlementDate: new Date(operation.settlementDate),
  netUnitPrice: operation.netUnitPrice,
  quantity: operation.quantity,
  volume: operation.volume ?? undefined,
  executionPlace: operation.executionPlace
    ? parseExecutionPlaceEntity(operation.executionPlace)
    : undefined,
  number: operation.number,
  executedAt: new Date(operation.executedAt),
  orderOperationType: OrderOperationType[operation.order.operationType],
  orderNumber: String(operation.order.number),
  orderExecutionTermsOrderType: operation.order.orderType
    ? OrderExecutionTermsOrderType[operation.order.orderType]
    : undefined,
  orderEndDate: operation.order.endDate
    ? new Date(operation.order.endDate)
    : undefined,
  executedRequested: `${operation.order.executedQuantity} / ${operation.order.requestedQuantity}`,
  orderStatus: OrderStatusType[operation.order.status],
  isin: operation.order.isin,
  currency: operation.order.currency ?? undefined,
  clientName: operation.order.ownerFullName ?? undefined,
  type: OperationType[operation.type],
});
